// extracted by mini-css-extract-plugin
export default {"landing":"landing_landing__e+y76","landing__logo":"landing_landing__logo__ufW6m"};